import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { ExError } from '@shared';

const verifyPartnerLinkRequestSlice = createSlice({
  name: 'verifyPartnerLinkRequest',
  initialState: initialState.verifyPartnerLinkRequest,
  reducers: {
    clearVerifyPartnerLinkRequest(state) {
      state.status = null;
      state.errorMessage = null;
    },
    postPartnerLinkRequestUpdateStatusRequest(
      state,
      action: PayloadAction<{
        clientId: string;
        partnerClientId: string;
        status: PartnerLinkRequestStatus;
      }>,
    ) {
      state.status = 'loading';
    },
    postPartnerLinkRequestUpdateStatusResponse(
      state,
      _action: PayloadAction<string>,
    ) {
      state.status = 'complete';
    },
    postPartnerLinkRequestUpdateStatusFailure(
      state,
      _action: PayloadAction<ExError>,
    ) {
      state.status = 'error';
    },
  },
});

export const {
  clearVerifyPartnerLinkRequest,
  postPartnerLinkRequestUpdateStatusRequest,
  postPartnerLinkRequestUpdateStatusResponse,
  postPartnerLinkRequestUpdateStatusFailure,
} = verifyPartnerLinkRequestSlice.actions;

export const verifyPartnerLinkRequestReducer =
  verifyPartnerLinkRequestSlice.reducer;
